/** Resolve image URL whether it's a public path, /api/uploads or external. */
export function resolveImageUrl(url) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    if (url.startsWith("/api/")) {
        const base = process.env.REACT_APP_BACKEND_URL || "";
        return `${base}${url}`;
    }
    return url; // /images/foo.jpg or /brand/...
}
